import { render, staticRenderFns } from "./TextTemplateModal.vue?vue&type=template&id=61b62ca5&"
import script from "./TextTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./TextTemplateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports